import axios from "axios";

export const axiosInstance = axios.create({
  //baseURL: "http://127.0.0.1:3000",
  baseURL: "https://dev-api.limberhealth.com/v2",
});

export const getRequest = (path) => {
  return axiosInstance.get(path);
};

export const putRequest = (path, body) => {
  return axiosInstance.put(path, body);
};

export const postRequest = (path, body) => {
  return axiosInstance.post(path, body);
};
